module.exports = __webpack_public_path__ + "img/icon-about-4.3b174f8f.png";